/**
 * Header Component
 * Top navigation bar with theme toggle and user menu dropdown
 */

import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { Moon, Sun, Menu, User, CreditCard, LogOut } from 'lucide-react';

const Header = ({
  dropdownOpen,
  onMenuClick,
  onCloseDropdown,
  onProfileClick,
  onPaymentsClick,
  onLogoutClick,
  onThemeToggle,
  theme,
}) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        onCloseDropdown();
      }
    };
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownOpen, onCloseDropdown]);

  return (
    <header className="app-header">
      <div className="header-left" ref={dropdownRef}>
        <button
          className="menu-button"
          onClick={onMenuClick}
          aria-label="Menu"
          aria-expanded={dropdownOpen}
          aria-haspopup="true"
        >
          <Menu size={20} />
        </button>
        <Link to="/app" className="logo" onClick={onCloseDropdown}>
          <img src="/logo.png" alt="GONGFU" className="logo-image" />
          <span className="logo-text">gongfu</span>
        </Link>
        {dropdownOpen && (
          <div className="header-dropdown">
            <button className="header-dropdown-item" onClick={() => { onProfileClick(); onCloseDropdown(); }}>
              <User size={18} />
              <span>Profile</span>
            </button>
            <button className="header-dropdown-item" onClick={() => { onPaymentsClick(); onCloseDropdown(); }}>
              <CreditCard size={18} />
              <span>Payments</span>
            </button>
            <button className="header-dropdown-item header-dropdown-item-logout" onClick={() => { onLogoutClick(); onCloseDropdown(); }}>
              <LogOut size={18} />
              <span>Log out</span>
            </button>
          </div>
        )}
      </div>

      <div className="header-right">
        <button
          className="theme-toggle"
          onClick={onThemeToggle}
          aria-label="Toggle theme"
        >
          {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
        </button>
      </div>
    </header>
  );
};

export default Header;


